"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EmailPasswordLoginForm;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _material = require("@mui/material");
var _formik = require("formik");
var _InputAdornment = _interopRequireDefault(require("@mui/material/InputAdornment"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _Visibility = _interopRequireDefault(require("@mui/icons-material/Visibility"));
var _VisibilityOff = _interopRequireDefault(require("@mui/icons-material/VisibilityOff"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _universalCookie = _interopRequireDefault(require("universal-cookie"));
var _AcceptGTCU = _interopRequireDefault(require("./AcceptGTCU"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function EmailPasswordLoginForm(props) {
  const {
    setemailPasswordCardType,
    afterSignInRedirect,
    auth,
    signinCallback = () => {},
    signInWithEmailAndPassword,
    navigate,
    t,
    globalActions,
    Link,
    gtcuCookieName
  } = props;
  const [showPassword, setShowPassword] = (0, _react.useState)(false);
  const [acceptedGTCU, setacceptedGTCU] = (0, _react.useState)(false);
  const [showGTCUError, setshowGTCUError] = (0, _react.useState)(false);
  const cookies = new _universalCookie.default();
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  async function signIn(email, password, setSubmitting) {
    if (!acceptedGTCU) {
      return setshowGTCUError(true);
    }
    try {
      await signInWithEmailAndPassword(auth, email, password);
      signinCallback();
      if (!afterSignInRedirect) {
        navigate('/');
      } else {
        navigate(afterSignInRedirect);
      }
    } catch (err) {
      globalActions.setSnackbarMessage({
        message: err.message,
        severity: 'error'
      });
    } finally {
      setSubmitting(false);
    }
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    initialValues: {
      email: '',
      password: ''
    },
    validate: values => {
      const errors = {};
      if (!values.email) {
        errors.email = t('validations.required');
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
        errors.email = t('validations.email_invalid');
      }
      if (!values.password) {
        errors.password = t('validations.required');
      }
      return errors;
    },
    onSubmit: async (values, _ref) => {
      let {
        setSubmitting
      } = _ref;
      // storing on both localStorage(stays longer) and cookies (sent to server) just in case
      localStorage.setItem(gtcuCookieName, 'true');
      cookies.set(gtcuCookieName, 'true');
      await signIn(values.email, values.password, setSubmitting);
    }
  }, _ref2 => {
    let {
      values,
      errors,
      touched,
      handleChange,
      handleBlur,
      handleSubmit,
      isSubmitting
      /* and other goodies */
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement("form", {
      style: {
        width: '100%'
      },
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react.default.createElement(_Box.default, {
      sx: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 2,
        width: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement(_Box.default, {
      sx: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        width: '100%',
        gap: 1
      }
    }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
      style: {
        maxWidth: 300
      },
      fullWidth: true,
      type: "email",
      name: "email",
      onChange: handleChange,
      onBlur: handleBlur,
      value: values.email,
      label: t('signin.email'),
      error: touched.email && Boolean(errors.email),
      helperText: errors.email && touched.email && errors.email
    }), /*#__PURE__*/_react.default.createElement(_TextField.default, {
      style: {
        maxWidth: 300
      },
      fullWidth: true,
      type: showPassword ? 'text' : 'password',
      name: "password",
      error: touched.password && Boolean(errors.password),
      helperText: errors.password && touched.password && errors.password,
      onChange: handleChange,
      onBlur: handleBlur,
      value: values.password,
      label: t('signin.password'),
      InputProps: {
        endAdornment: /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
          position: "end"
        }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
          "aria-label": "toggle password visibility",
          onClick: handleClickShowPassword,
          edge: "end"
        }, showPassword ? /*#__PURE__*/_react.default.createElement(_VisibilityOff.default, null) : /*#__PURE__*/_react.default.createElement(_Visibility.default, null)))
      }
    })), /*#__PURE__*/_react.default.createElement(_material.Link, {
      sx: {
        cursor: 'pointer'
      },
      onClick: () => setemailPasswordCardType('passwordForgotten'),
      color: "secondary"
    }, t('signin.password_forgotten')), /*#__PURE__*/_react.default.createElement(_AcceptGTCU.default, {
      acceptedGTCU: acceptedGTCU,
      setacceptedGTCU: setacceptedGTCU,
      showGTCUError: showGTCUError,
      setshowGTCUError: setshowGTCUError,
      t: t,
      Link: Link
    }), /*#__PURE__*/_react.default.createElement(_Button.default, {
      variant: "contained",
      color: "primary",
      type: "submit",
      disabled: isSubmitting
    }, t('signin.login'))));
  }));
}